import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useElementSize } from "@vueuse/core";
import { ref, computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'MasonryListItem',
    props: {
        gridAutoRows: {},
        gridRowGap: {},
        isShown: { type: Boolean },
        negativeMargin: {}
    },
    setup(__props) {
        const props = __props;
        const container = ref(null);
        const containerHeight = useElementSize(container).height;
        const style = computed(() => {
            const minimumRowSpan = Math.ceil((containerHeight.value + props.gridRowGap - (props.negativeMargin * 2)) /
                (props.gridAutoRows + props.gridRowGap));
            return {
                "grid-row-end": `span ${minimumRowSpan}`,
            };
        });
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
                style: _normalizeStyle(style.value)
            }, [
                _createElementVNode("div", {
                    ref_key: "container",
                    ref: container
                }, [
                    _renderSlot(_ctx.$slots, "default")
                ], 512 /* NEED_PATCH */)
            ], 4 /* STYLE */)), [
                [_vShow, _ctx.isShown]
            ]);
        };
    }
});
